import { MSG_SELECIONAR_TODOS } from '../../shared/constantes/mensagens';
import utc from 'dayjs/plugin/utc'
import dayjs from 'dayjs'

dayjs.extend(utc);

const INITIAL_STATE = {
    erroDeSolicitacao: null,
    esperandoSolicitacao: false,
    dataPagamento: dayjs.utc().format('YYYY-MM-DD'),
    anoSelecionado: '',
    anos: [],
    dataCalculo: new Date(),
    mensagem: '',
    contribuicoes: [],
    criticas: [],
    guia: null
};

export default (state= INITIAL_STATE, action) => {
    switch(action.type){

        case 'CISM_BUSCAR_CONTRIBUICOES': {
            let contribuicoes = action.payload.contribuicoes;
            let criticas = action.payload.criticas;
            let anos = [];

            if (contribuicoes && 
                contribuicoes.length > 0) {
                
                contribuicoes.forEach(contrib => {
                    if(!anos.includes(contrib.competencia.ano)){
                        anos.push(contrib.competencia.ano);
                    }
                });
            }
            if (anos.length > 0) {
              anos.sort();
              anos.reverse();
              anos.push(MSG_SELECIONAR_TODOS);
            }
      
            return {...state, 
                contribuicoes: contribuicoes, 
                anos: anos,
                criticas: criticas,
                dataPagamento: action.payload.dataPagamento,
                esperandoSolicitacao: false,
                anoSelecionado: (anos.length > 0) ? anos[0] : '', 
                mensagem: ''};
        }

        
        case 'CISM_ATUALIZAR_CONTRIBUICOES':
            return {...state, contribuicoes: action.payload, mensagem: 'Contribuição atualizada.'};

        case 'CISM_ATUALIZAR_ANO_SELECIONADO':
            return {...state, anoSelecionado: action.payload, mensagem: 'Ano atualizado'};

        case 'CISM_ATUALIZAR_DATA_PAGAMENTO':
            return {...state, dataPagamento: action.payload, mensagem: 'Data de pagamento atualizado'};
        
        case 'CISM_PROCESSAR_REQUISICAO':
            return {...state, esperandoSolicitacao: true, mensagem: '', error: null};

        case 'CISM_CALCULO_ATUALIZAR_COMPETENCIAS':
            return {...state, esperandoSolicitacao: false, mensagem: '', error: null, ...action.payload};
        
        case 'CISM_CALCULO_ERRO_RECEBIDO':
            return {...state, esperandoSolicitacao: false, mensagem: action.payload, error: action.payload};

        case 'CISM_ATUALIZAR_DADOS_GUIA':
            return {...state, esperandoSolicitacao: false, mensagem: '', error: null, guia: action.payload};
    
        case 'ERRO_GERAR_GUIA':
            return {...state, esperandoSolicitacao: false, mensagem: action.payload, error: action.payload}; 
        
        case 'CISM_IMPRESSAO_RECEBIDA':{
            return action.payload.msg ?
                    {...state, esperandoSolicitacao: false, msg: action.payload.data, error: action.payload.msg}:
                    {...state, esperandoSolicitacao: false, mensagem: '', error: null};
        }

        case 'CISM_ERRO_GERAR_GUIA':
            return {...state, esperandoSolicitacao: false, mensagem: action.payload, error: action.payload};      

        default:
           return state;
    }
}
